import React from "react";

export type CertificateMatch = {
  provider: "blancco" | "certus" | "legacy";
  label: string;
  uuid?: string;
  assetId?: number | null;
  reportDate?: string | null;
  signedUrl?: string | null;
  bucketPath?: string | null;
  serialNormalized?: string | null;
  dataBase64?: string; // för blancco/certus utan signedUrl
  contentType?: string;
  filename?: string;
};

interface CertificateMatchListProps {
  matches: CertificateMatch[];
}

export const CertificateMatchList: React.FC<CertificateMatchListProps> = ({ matches }) => {
  if (!matches || matches.length === 0) return null;

  const openMatch = (m: CertificateMatch) => {
    if (m.signedUrl) {
      window.open(m.signedUrl, "_blank");
      return;
    }
    if (m.dataBase64 && m.contentType) {
      const byteCharacters = atob(m.dataBase64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      const blob = new Blob(byteArrays, { type: m.contentType });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 30_000);
    }
  };

  return (
    <div className="mt-3" role="status" aria-live="polite">
      <ul style={{ margin: 0, paddingLeft: 0, display: "grid", gap: 8 }}>
        {matches.map((m, idx) => (
          <li
            key={`${m.provider}-${m.uuid || idx}`}
            className="flex justify-between gap-3 items-start rounded border border-[color:var(--border)] bg-[color:var(--surface-2)] px-3 py-2"
          >
            <div className="flex-1 min-w-0">
              <div className="font-medium" style={{ overflowWrap: "anywhere" }}>
                [{m.provider}] {m.label}
                {m.reportDate ? ` (${m.reportDate})` : ""}
              </div>
              {m.bucketPath && (
                <div className="text-muted text-xs break-all" style={{ overflowWrap: "anywhere" }}>
                  {m.bucketPath}
                </div>
              )}
            </div>
            <button
              type="button"
              className="gw-btn gw-btn-primary gw-btn-xs whitespace-nowrap"
              onClick={() => openMatch(m)}
              disabled={!m.signedUrl && !m.dataBase64}
            >
              {m.signedUrl || m.dataBase64 ? "Öppna" : "Ingen länk"}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
